import React from 'react';
import * as ToggleGroup from '@radix-ui/react-toggle-group';

import { bemBlock } from '../../modules/bem';

import './ToggleSwitchButton.less';

const block = bemBlock('n-toggle-switch-button');

type ToggleSwitchButtonProps = React.ComponentPropsWithoutRef<typeof ToggleGroup.Item>;

export const ToggleSwitchButton = React.forwardRef<HTMLButtonElement, ToggleSwitchButtonProps>(
  function ToggleSwitchButton({ children, className, ...passProps }, ref) {
    return (
      <ToggleGroup.Item ref={ref} className={block({ extra: className })} {...passProps}>
        {children}
      </ToggleGroup.Item>
    );
  },
);
